import { GridCellContentAlignment } from '@grid/enums';
import { ColorOptions, IAutoFocus, IIdentity, SelectionItem } from '.';

export interface SelectCellConfig<T extends IIdentity> extends IAutoFocus {
  options: SelectionItem[] | ((data: T) => SelectionItem[]);
  autoOpen?: boolean;
  searchPlaceholderLabel?: string;
  searchNoEntriesFoundLabel?: string;
  includeNoneOption?: boolean;
  noneOptionName?: string;
  alignment?: GridCellContentAlignment;
  colorOptions?: ColorOptions;
}
